import { useTranslation } from "@/i18n/client";
import { ContextModalProps } from "@mantine/modals";
import { Box } from "@mantine/core";
import { Modal } from "@/components/Modal";
import ButtonsGroup from "@/components/ButtonsGroup";
import React, { ReactNode } from "react";
import { useContractState } from "@/hooks/useContractState";
import { useStornoRequestMutation } from "@/screens/Recapitulation/useStornoRequestMutation";
import { useRouter } from "next/navigation";
import { SCREENS } from "@/router/screens";
import { RequestStatusType } from "@/constants/request";
import { useQueryStorage } from "@/contexts/QueryStorageContext";

interface RequestInProgressProps {
  uuid: string;
  title?: string;
  description?: ReactNode;
  closeLabel?: string;
}

export const requestInProgressModalContext = {
  modal: "requestInProgress",
  closeOnClickOutside: false,
  closeOnEscape: false,
  withCloseButton: false,
  innerProps: {},
};

export const RequestInProgressModal = ({ context, id, innerProps }: ContextModalProps<RequestInProgressProps>) => {
  const router = useRouter();
  const { t } = useTranslation("modals");
  const { contract } = useContractState(true);
  const { resetStoredQueries } = useQueryStorage();
  const { uuid } = innerProps;

  const stornoMutation = useStornoRequestMutation();
  const isFinishedRequest = [RequestStatusType.FINISHED, RequestStatusType.FOR_APPROVAL].includes(contract?.requestStatus ?? "");
  const storedQueries = useQueryStorage().storedQueries;
  const processReasonFromURl = storedQueries["processReason"] as string;

  return (
    <Box pos="relative">
      <Modal.LoadingOverlay isLoading={stornoMutation.isPending} />
      <Modal.Title>{isFinishedRequest ? t("requestInProgress.finishedTitle") : t("requestInProgress.title")}</Modal.Title>
      <Modal.Description
        description={isFinishedRequest ? t("requestInProgress.finishedDescription") : t("requestInProgress.description")}
      />
      {isFinishedRequest ? (
        <ButtonsGroup
          rightButtonText={t("requestInProgress.oneButton")}
          onRightButtonClick={() => context.closeModal(id)}
          fullWidth
          withLeftButton={false}
        />
      ) : (
        <ButtonsGroup
          leftButtonText={t("requestInProgress.leftButton")}
          rightButtonText={t("requestInProgress.rightButton")}
          onLeftButtonClick={() =>
            stornoMutation.mutate(
              { uuid, body: { role: "customer_old" } },
              {
                onSuccess: () => {
                  router.replace(
                    `${SCREENS.REQUEST_NEW_WELCOME}?commodity=01&customer_type=household&process=PS&process_reason=${processReasonFromURl}&source=WEB`
                  );
                  context.closeModal(id);
                },
              }
            )
          }
          onRightButtonClick={() => {
            resetStoredQueries();
            context.closeModal(id);
          }}
          fullWidth
        />
      )}
    </Box>
  );
};
